import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import LicenseKeyPageContent from '@shared/components/organization/licenseKey/LicenseKeyPageContent';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgLicenseKeyPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <OrgPageTemplate>
            <PageHeader
                title={t('common:license.key.titlePlural')}
                description={t('common:license.key.description')}
                items={items}></PageHeader>
            <LicenseKeyPageContent />
        </OrgPageTemplate>
    );
}
